// TODO: Use this color map in gatsby-browser.js
export const COLORS = {
  red: [
    ['base', '#FC7F6E'],
    ['highlighted', '#EB5F4C'],
    ['muted', '#512A24'],
  ],
  orange: [
    ['base', '#FDB26D'],
    ['highlighted', '#F09847'],
    ['muted', '#684A2E'],
  ],
  yellow: [
    ['base', '#F9D06C'],
    ['highlighted', '#EABA43'],
    ['muted', '#6C5A2F'],
  ],
  blue: [
    ['base', '#81A2FA'],
    ['highlighted', '#5D82E5'],
    ['muted', '#2E3A5B'],
  ],
  green: [
    ['base', '#A8DE7C'],
    ['highlighted', '#8EC95F'],
    ['muted', '#496235'],
  ],
  inverted: [
    ['base', '#000000'],
    ['highlighted', '#262626'],
    ['muted', '#757575'],
  ],
  light: [
    ['base', '#ffffff'],
    ['highlighted', '#EEEEEE'],
    ['muted', 'rgba(0, 0, 0, 0.75)'],
  ],
}

export function setColors(color) {
  const colors = COLORS[color]
  const root = document.documentElement

  colors.forEach(([key, value]) => {
    root.style.setProperty(`--color-${key}`, value)
  })
}
